import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import BarList from './BarList';

import transformArrayToBarChartObject from '../utils/transformArrayToBarChartObject';

const ChartWrapper = styled.div`
  height: ${props => props.theme.components.chartHeight};
  display: flex;
`;

function ExperiencesVisualisation({ data }) {
  if (!data?.experiences) return false;

  const transformedData = transformArrayToBarChartObject(
    data?.experiences.slice(0, 5),
    null,
    null,
    'title',
    false,
  );

  return (
    <ChartWrapper>
      <BarList data={transformedData} />
    </ChartWrapper>
  );
}

ExperiencesVisualisation.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};
export default ExperiencesVisualisation;
